const versionCompare = (v1,v2) => {
  const arr1 = (v1 || "").toString().replace(/[^\d\.]/g, '').split('.').map((x)=>(parseInt(x)))
  const arr2 = (v2 || "").toString().replace(/[^\d\.]/g, '').split('.').map((x)=>(parseInt(x)))
  for (let index = 0; index < Math.max(arr1.length, arr2.length); index++) {
    const a1 = (arr1.at(index) || 0)
    const a2 = (arr2.at(index) || 0)
    if(a1 > a2 ) { return 1 }
    if(a1 < a2 ) { return -1 }
  }
  return 0
}

export default versionCompare